export default {"src":"/_next/static/media/wine.7eabbe8c.svg","height":22,"width":12,"blurWidth":0,"blurHeight":0};